/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Contact_CtaInputs */

const en_about_contact_cta = /** @type {(inputs: About_Contact_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how we work together`)
};

const lv_about_contact_cta = /** @type {(inputs: About_Contact_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt, kā strādājam kopā`)
};

/**
* | output |
* | --- |
* | "See how we work together" |
*
* @param {About_Contact_CtaInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_contact_cta = /** @type {((inputs?: About_Contact_CtaInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Contact_CtaInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_contact_cta(inputs)
	return en_about_contact_cta(inputs)
});